import AttachmentsDetails from './attachments-details'
import CardStatus from '@/components/_modules/Programs/Card-cards/CardStatus.vue'
import { gotoCustom } from '@/components/Grid/cells/actions'

export default {
  'CardNumber': {
    label: 'Card Number',
    compose: maskedCardNumber,
    width: 100
  },
  'Holder': {
    label: 'Card Holder',
    width: 120
  },
  'CardStatus': {
    label: 'Status',
    source: 'CardList',
    render: CardStatus,
    width: 120
  },
  'WaitingApproval': {
    label: 'Waiting Approval',
    details: 'local',
    detailsCondition: showAttachmentsExpandIcon,
    detailsParamsURL: getAttachmentsDetailsParams,
    detailsComp: AttachmentsDetails,
    width: 140
  },
  'Division': {
    label: 'Division',
    getter: getDivisionLink,
    width: 140
  },
  'Spent': {
    label: 'Spent',
    type: 'money',
    f: 'data.Spent',
    width: 120
  },
  'Balance': {
    label: 'Balance',
    type: 'money',
    f: 'data.Balance',
    width: 120
  },
  'InitialLoad': {
    label: 'Initial Load',
    type: 'money',
    f: 'data.InitialLoad',
    width: 120
  },
  'Refills': {
    label: 'Refills',
    type: 'money',
    f: 'data.Refills',
    width: 120
  },
  'Pending': {
    label: 'Pending Request',
    type: 'money',
    f: 'data.Pending',
    width: 120
  },
  'ReturnedAmount': {
    label: 'Return to Acct',
    type: 'money',
    f: 'data.ReturnedAmount',
    width: 130
  },
  AccountId: '_'
}

function maskedCardNumber(card) {
  if (card && card.data && card.data.CardNumber) {
    return '****' + card.data.CardNumber
  } else {
    return '****'
  }
}

function showAttachmentsExpandIcon(params) {
  return parseInt(params.data.WaitingApproval) > 0
}
function getAttachmentsDetailsParams(params) {
  return `?cardId=${params.data.Id}`
}

function getDivisionLink(params) {
  if (params && params.data && params.data.AccountId) {
    params.node.uri = params.colDef.uri = `#/d/Programs/>Card/list?AccountId=${params.data.AccountId}`
    params.value = params.data.Division
    params.noTooltip = true

    return gotoCustom.template(params)
  } else {
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/components/_modules/Programs/Card-cards/model.js